import axios from 'axios'

export const login = async (identifier, password) => {
  try {
    // Use the correct token endpoint
    const res = await axios.post('/api/token/', {
      login: identifier,  // This can be either username or email
      password
    })
    
    console.log('Login response:', res.data) // Debug log
    
    // Check if code is running in browser environment
    if (typeof window !== 'undefined') {
      localStorage.setItem('access_token', res.data.access)
      localStorage.setItem('refresh_token', res.data.refresh)
      // Store the identifier so we can retrieve it later
      localStorage.setItem('username', identifier)
      
      console.log('Stored tokens:', {
        access: res.data.access?.substring(0, 50) + '...',
        refresh: res.data.refresh?.substring(0, 50) + '...'
      })
    }
    return true
  } catch (err) {
    console.error('Login failed:', err.response?.data || err.message)
    return false
  }
}

export const getUsernameFromToken = () => {
  // Check if code is running in browser environment
  if (typeof window === 'undefined') {
    return null
  }
  
  const token = localStorage.getItem('access_token')
  if (!token) {
    console.log('getUsernameFromToken: No token found')
    return null
  }
  
  try {
    const payload = JSON.parse(atob(token.split('.')[1]))
    
    // Check if token is expired
    const currentTime = Math.floor(Date.now() / 1000)
    console.log('Token expiration check:', {
      currentTime,
      tokenExp: payload.exp,
      isExpired: payload.exp && payload.exp < currentTime,
      timeUntilExpiry: payload.exp ? payload.exp - currentTime : 'no exp'
    })
    
    if (payload.exp && payload.exp < currentTime) {
      console.log('Token is expired, clearing localStorage')
      // Token is expired, clear it
      localStorage.removeItem('access_token')
      localStorage.removeItem('refresh_token')
      localStorage.removeItem('username')
      localStorage.removeItem('user_id')
      return null
    }
    
    // Store the user_id in localStorage to use it later if needed
    if (payload.user_id) {
      localStorage.setItem('user_id', payload.user_id)
    }
    
    // If we have a stored username from login, use that instead
    const storedUsername = localStorage.getItem('username')
    if (storedUsername) {
      return storedUsername
    }
    
    // Fall back to user_id if no username is available
    return payload.username || 'User'
  } catch {
    // Invalid token, clear it
    localStorage.removeItem('access_token')
    localStorage.removeItem('refresh_token')
    localStorage.removeItem('username')
    localStorage.removeItem('user_id')
    return null
  }
}

export const getIsStaffFromToken = () => {
  // Check if code is running in browser environment
  if (typeof window === 'undefined') {
    return false
  }
  
  const token = localStorage.getItem('access_token')
  if (!token) {
    return false
  }
  
  try {
    const payload = JSON.parse(atob(token.split('.')[1]))
    return payload.is_staff === true
  } catch {
    return false
  }
}

export const logout = () => {
  // Check if code is running in browser environment
  if (typeof window !== 'undefined') {
    localStorage.removeItem('access_token')
    localStorage.removeItem('refresh_token')
    localStorage.removeItem('username')
    localStorage.removeItem('user_id')
  }
}

export const isAuthenticated = () => {
  // Check if code is running in browser environment
  if (typeof window === 'undefined') {
    return false
  }
  
  const token = localStorage.getItem('access_token')
  if (!token) {
    console.log('isAuthenticated: No token found')
    return false
  }
  
  try {
    const payload = JSON.parse(atob(token.split('.')[1]))
    
    // Check if token is expired
    const currentTime = Math.floor(Date.now() / 1000)
    const isExpired = payload.exp && payload.exp < currentTime
    
    console.log('isAuthenticated check:', {
      hasToken: !!token,
      currentTime,
      tokenExp: payload.exp,
      isExpired,
      result: !isExpired
    })
    
    if (isExpired) {
      console.log('isAuthenticated: Token is expired, clearing localStorage')
      // Token is expired, clear it
      localStorage.removeItem('access_token')
      localStorage.removeItem('refresh_token')
      localStorage.removeItem('username')
      localStorage.removeItem('user_id')
      return false
    }
    
    return true
  } catch (e) {
    console.log('isAuthenticated: Error parsing token:', e)
    // Invalid token, clear it
    localStorage.removeItem('access_token')
    localStorage.removeItem('refresh_token')
    localStorage.removeItem('username')
    localStorage.removeItem('user_id')
    return false
  }
}
